import { useTranslation } from "react-i18next";
import { BsBank, BsChatTextFill, BsRobot } from "react-icons/bs";
import {
  FaBalanceScale,
  FaRoute,
  FaStar,
  FaTools,
  FaUser,
} from "react-icons/fa";
import { GiCarWheel } from "react-icons/gi";
import { GrTransaction, GrTroubleshoot } from "react-icons/gr";
import { IoSettings } from "react-icons/io5";
import {
  RiDashboardFill,
  RiFileList3Line,
  RiInfoCardLine,
  RiParentFill,
  RiSecurePaymentFill,
} from "react-icons/ri";
import { SlCalender } from "react-icons/sl";
import { DriverIcon } from "../../assets/images/driver";
import { BusCharterIcon, SubscriptionBusIcon } from "../../assets/images/Icons";
import Sidebar from "../Sidebar";
import { FiCreditCard } from "react-icons/fi";
import { MdOutlinePayments, MdPayments } from "react-icons/md";
import { FaTruckFront } from "react-icons/fa6";
import { TbCreditCardPay } from "react-icons/tb";
import { SiWebmoney } from "react-icons/si";
import { IoMdAnalytics } from "react-icons/io";

const SideMenu = ({ setCollapsedFromSidebar, isCollapsed }) => {
  const { t } = useTranslation();

  const menus = [
    {
      type: "link",
      text: t("ask_ai"),
      icon: <BsRobot />,
      to: "/ask-ai",
    },

    {
      type: "link",
      text: t("dashboard"),
      icon: <RiDashboardFill />,
      to: "/dashboard",
    },

    {
      type: "link",
      text: t("tracking"),
      icon: <FaRoute />,
      to: "/tracking",
    },

    {
      type: "dropdown",
      text: `${t("parents")} ${t("management")}`,
      icon: <RiParentFill />,
      children: [
        {
          type: "link",
          text: t("parents"),
          icon: <RiParentFill />,
          to: "/parents",
        },
        {
          type: "link",
          text: `${t("all")} ${t("students")}`,
          icon: <RiParentFill />,
          to: "/students",
        },
      ],
    },
    {
      type: "link",
      text: t("drivers"),
      icon: <DriverIcon />,
      to: "/drivers",
    },

    /* Reservations */
    {
      type: "dropdown",
      text: `${t("reservations")} & ${t("subscriptions")}`,
      icon: <SlCalender />,
      children: [
        {
          type: "dropdown",
          text: `${t("vendor")} ${t("reservations")}`,
          icon: <SlCalender />,
          children: [
            {
              type: "link",
              text: `${t("bus")} ${t("charter")} ${t("reservation")}`,
              icon: <BusCharterIcon />,
              to: "/bus-charter-reservations",
            },
            {
              type: "link",
              text: `${t("busing")} ${t("subscriptions")}`,
              icon: <SubscriptionBusIcon />,
              to: "/busing-subscriptions",
            },
          ],
        },
        {
          type: "dropdown",
          text: `${t("school")} ${t("reservations")}`,
          icon: <SlCalender />,
          children: [
            {
              type: "link",
              text: `${t("bus")} ${t("charter")} ${t("reservation")}`,
              icon: <BusCharterIcon />,
              to: "/my-bus-reservations",
            },
            {
              type: "link",
              text: `${t("busing")} ${t("subscriptions")}`,
              icon: <SubscriptionBusIcon />,
              to: "/my-busing-subscriptions",
            },
          ],
        },
      ],
    },

    /* Vehicles Management */
    {
      type: "dropdown",
      text: `${t("vehicles")} ${t("management")}`,
      icon: <FaTools />,
      children: [
        {
          type: "link",
          text: t("vehicles"),
          icon: <FaTruckFront />,
          to: "/vehicles",
        },
        {
          type: "link",
          text: `${t("route")} ${t("and")} ${t("schedule")}`,
          icon: <FaRoute />,
          to: "/route-and-schedule",
        },
        {
          type: "link",
          text: `${t("maintenance")} ${t("and")} ${t("inspection")}`,
          icon: <GiCarWheel />,
          to: "/maintenance-and-inspection",
        },
        {
          type: "link",
          text: `${t("regulatory")} ${t("compliance")}`,
          icon: <FaBalanceScale />,
          to: "/regulatory-compliance",
        },
        // {
        //   type: "link",
        //   text: `${t("verification")} ${t("logs")}`,
        //   icon: <RiFileList3Line />,
        //   to: "/school/verification-logs",
        // },
      ],
    },
    {
      type: "dropdown",
      text: `${t("payments")}`,
      icon: <GrTransaction />,
      children: [
        {
          type: "link",
          text: `${t("make")} ${t("payment")}`,
          icon: <FiCreditCard />,
          to: "/make-payment",
        },
        {
          type: "link",
          text: `${t("receive")} ${t("payment")}`,
          icon: <MdOutlinePayments />,
          to: "/receive-payment",
        },
      ],
    },

    {
      type: "link",
      text: `${t("subscription")} ${t("plans")}`,
      icon: <BsBank />,
      to: "/subscription-plans",
    },
    {
      type: "dropdown",
      text: `${t("payments")} ${t("history")}`,
      icon: <GrTransaction />,
      children: [
        {
          type: "link",
          text: `${t("subscription")} ${t("history")}`,
          icon: <SiWebmoney />,
          to: "/payment-history",
        },
        {
          type: "link",
          text: `${t("parent")} ${t("payments")}`,
          icon: <MdPayments />,
          to: "/parent-payments-received",
        },
        {
          type: "link",
          text: `${t("manual")} ${t("payments")} ${t("history")}`,
          icon: <TbCreditCardPay />,
          to: "/manual-payment-history",
        },
        {
          type: "link",
          text: `${t("receive")} ${t("payments")} ${t("history")}`,
          icon: <MdOutlinePayments />,
          to: "/receive-payment-history",
        },
      ],
    },

    {
      type: "link",
      text: `${t("reporting")} ${t("and")} ${t("analytics")}`,
      icon: <IoMdAnalytics />,
      to: "/reporting-and-analytics",
    },

    {
      type: "link",
      text: `${t("user")} ${t("communication")}`,
      icon: <BsChatTextFill />,
      to: "/user-communication",
    },

    /* System Configuration */
    {
      type: "dropdown",
      text: `${t("system")} ${t("configuration")}`,
      icon: <RiInfoCardLine />,
      children: [
        {
          type: "link",
          text: `${t("manage")} ${t("bus")} ${t("fee")}`,
          icon: <BsBank />,
          to: "/bus-fee",
        },
      ],
    },

    {
      type: "link",
      text: `${t("ratings")} ${t("and")} ${t("reviews")}`,
      icon: <FaStar />,
      to: "/ratings-and-reviews",
    },
    {
      type: "link",
      text: `${t("support")} ${t("and")} ${t("troubleshooting")}`,
      icon: <GrTroubleshoot />,
      to: "/support",
    },
    {
      type: "link",
      text: t("settings"),
      icon: <IoSettings />,
      to: "/settings",
    },
  ];

  return (
    <>
      <Sidebar
        setCollapsedFromSidebar={setCollapsedFromSidebar}
        menu={menus}
        isCollapsed={isCollapsed}
        title="School"
      />
    </>
  );
};

export default SideMenu;
